import { List, Stack } from "@chakra-ui/react";
import { HeaderLinkGroup } from "./HeaderLinkGroup";
import { isHeaderLinkGroup } from "../../Header.utils";
import { HeaderLink } from "../../HeaderLink";
import type { HeaderProps } from "../../types";

export const HeaderLinks = ({ headerLinks }: Pick<HeaderProps, "headerLinks">) => (
  <Stack as={List} direction="row" spacing={6} pt={6}>
    {headerLinks.map((headerLinkItem) =>
      isHeaderLinkGroup(headerLinkItem) ? (
        <HeaderLinkGroup
          key={headerLinkItem._uid}
          headerLinksGroupItems={headerLinkItem.headerLinksGroupItems}
          headerLinksGroupMainGroupLinkSource={headerLinkItem.headerLinksGroupMainGroupLinkSource}
          headerLinksGroupMainGroupLinkName={headerLinkItem.headerLinksGroupMainGroupLinkName}
          headerLinksGroupMainGroupLinkNameTrackingEvent={headerLinkItem.headerLinksGroupMainGroupLinkNameTrackingEvent}
        />
      ) : (
        <HeaderLink {...headerLinkItem} key={headerLinkItem._uid} />
      )
    )}
  </Stack>
);
